module.exports = __webpack_public_path__ + "media/components/web/pages/index/resources/svgs/pattern_left-3b493ae82bd018a7454009d30e4a32b9.svg";